module.exports = __webpack_public_path__ + "static/media/drumstick.60f97ba2.webp";